var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,56A24,24,0,1,1,56,32,24,24,0,0,1,32,56Zm0-46A22,22,0,1,0,54,32,22,22,0,0,0,32,10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5,40.5a1,1,0,0,1-.71-.29l-6-6a1,1,0,0,1,1.42-1.42l5.29,5.3,14.29-14.3a1,1,0,0,1,1.42,1.42l-15,15A1,1,0,0,1,27.5,40.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.516ae08e2ad49ec3a4d4fda272e62ae1.svg";
export { ForwardRef as ReactComponent };